import { createMountBridgeController } from "@/controllers/mount_bridge"

export default createMountBridgeController(
  "mountParamsCombobox",
  "unmountParamsCombobox",
)
